exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header .v-toolbar__content{width:auto}.v-application .elevation-1{border:0;webkit-box-shadow:none!important;-webkit-box-shadow:none!important;box-shadow:none!important}.v-input--selection-controls .v-input__slot>.v-label,.v-input--selection-controls .v-radio>.v-label{font-size:12px}.v-input--selection-controls.v-input{margin-bottom:-4px}.auth-provider,.auto-posting-frequency input[type=number]{text-align:center}.auth-provider{width:48%;padding:3px}", ""]);

// exports
